import { Settings } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SettingsIcon = createLucideIcon(Settings);
